// extracted by mini-css-extract-plugin
export var addNoScroll = "ImageGallery-module--add-no-scroll--18581";
export var cdsAssistiveText = "ImageGallery-module--cds--assistive-text--ac7e8";
export var cdsHideFeedback = "ImageGallery-module--cds--hide-feedback--098ee";
export var cdsShowFeedback = "ImageGallery-module--cds--show-feedback--5dfa5";
export var cdsSkeleton = "ImageGallery-module--cds--skeleton--e8f63";
export var cdsVisuallyHidden = "ImageGallery-module--cds--visually-hidden--fcd85";
export var closeButton = "ImageGallery-module--close-button--9b0cd";
export var column = "ImageGallery-module--column--c55c7";
export var figure = "ImageGallery-module--figure--44e75";
export var firstRightNav = "ImageGallery-module--first-right-nav--23aee";
export var galleryContainer = "ImageGallery-module--gallery-container--2236c";
export var galleryGrid = "ImageGallery-module--gallery-grid--37bdc";
export var galleryRow = "ImageGallery-module--gallery-row--ba890";
export var icon = "ImageGallery-module--icon--e435c";
export var imageButtonWrapper = "ImageGallery-module--image-button-wrapper--3e920";
export var imageInDialog = "ImageGallery-module--image-in-dialog--75be4";
export var imageTitle = "ImageGallery-module--image-title--fed90";
export var inDialogGalleryContainer = "ImageGallery-module--in-dialog-gallery-container--4fe04";
export var leftNav = "ImageGallery-module--left-nav--db194";
export var navButtons = "ImageGallery-module--nav-buttons--084cb";
export var navButtonsContainer = "ImageGallery-module--nav-buttons-container--00aba";
export var rightNav = "ImageGallery-module--right-nav--416a6";